import { getStateFromZip, validateAddress } from "services/Api"

export const ValidateFields = async ({ context, session, newAddressContext }) => {
    // Run validations concurrently
    var validationPromises = [
        ValidateMoveDate(session),
        ValidateEffDate(session),
        ValidateAddress1(session),
        ValidateCity(session),
        ValidateZipCode(session),
        ValidateGaraged(context, session)
    ];

    const validationResults = await Promise.all(validationPromises);
    var invalidResults = validationResults.filter(result => result.valid === false);

    if (invalidResults.length === 0) {
        const addressValidationResult = await ValidateAddress(context, session, newAddressContext);
        validationResults.push(addressValidationResult);
        invalidResults = validationResults.filter(result => result.valid === false);
    }

    return invalidResults;
}

const ValidateAddress1 = async (session) => {
    const field = session["homeAddress"];
    const pattern = /^\d+\s[A-Za-z0-9\s.,'-]{2,}(?:\s(Apt|Suite|Unit|#)\s?\d*\w*)?$/;
    const IsValid = field !== '' && pattern.test(field);

    return IsValid ?
        { valid: true }
        :
        { title: "Oops!", message: 'Please enter a valid street name.', valid: false };
}

const ValidateCity = async (session) => {
    const field = session["city"];
    const pattern = /^[A-Za-z]+(?:[\s-][A-Za-z]+)*$/;
    const IsValid = field !== '' && pattern.test(field);

    return IsValid ?
        { valid: true }
        :
        { title: "Oops!", message: 'Please enter a valid city.', valid: false }
}

const ValidateMoveDate = async (session) => {
    return session?.dateMoved ?
        { valid: true }
        :
        { title: "Oops!", message: 'Please enter a valid Date of Move.', valid: false }
}

const ValidateEffDate = async (session) => {

    return session?.requestedEffDate ?
        { valid: true }
        :
        { title: "Oops!", message: 'Please enter a valid Requested Effective Date.', valid: false }
}

// Regular expression to match 5-digit or ZIP+4 formats
const ValidateZipCode = async (session) => {
    const field = session["zip"];
    const zipCodePattern = /^[0-9]{5}(?:-[0-9]{4})?$/;
    var IsValid = zipCodePattern.test(field);

    return IsValid ?
        { valid: true }
        :
        { title: "Oops!", message: 'Please enter a valid zip code.', valid: false }
}

// API call to validate address
const ValidateAddress = async (context, session, newAddressContext) => {
    var zipCodeResp = await getStateFromZip({ postalCode: session["zip"] })
    var state = zipCodeResp?.data

    const data = {
        addrTypeCd: "ContactAddr",
        addr1: session["homeAddress"],
        city: session["city"],
        stateProvCd: state,
        postalCode: session["zip"],
        regionCd: "US",
        regionISOCd: "US"
    };
    const response = await validateAddress(data)
    var IsValid = response?.data == "Valid" ? true : false;

    if (IsValid) {
        newAddressContext.newAddress.state = state;
    }

    return IsValid ?
        { valid: true }
        :
        { title: "Oops!", message: `That is not a valid city/zip combination for a mailing address.`, valid: false }
}

const ValidateGaraged = async (context, session) => {
    const field = session["garaged"];
    const vehicles = context?.addressChangeClass?.vehicles?.vehiclesOnPolicy?.storedVehicles

    if (field == "0") {
        // Validates if any vehicle has been selected
        const allVehiclesInvalid = vehicles.every(vehicle =>
            !vehicle.hasOwnProperty('garaged') || vehicle?.garaged == false
        );

        if (allVehiclesInvalid) {
            return { title: "Oops!", message: `Please select a vehicle that will be garaged.`, valid: false }
        }
        // Validates if any of the input fields are empty
        else {
            for (var vehicle of vehicles) {
                if (vehicle?.garaged === true && vehicle?.garagedStreetAddress == "")
                    return { title: "Oops!", message: `Please provide the street address for ${vehicle?.Year} ${vehicle?.Make} ${vehicle?.Model}.`, valid: false }
                if (vehicle?.garaged === true && vehicle?.garagedCity == "")
                    return { title: "Oops!", message: `Please provide the city for ${vehicle?.Year} ${vehicle?.Make} ${vehicle?.Model}.`, valid: false }
                if (vehicle?.garaged === true && vehicle?.garagedZipCode == "")
                    return { title: "Oops!", message: `Please provide the zip code for ${vehicle?.Year} ${vehicle?.Make} ${vehicle?.Model}.`, valid: false }
            }
        }
    } else if (field == "") {
        return { title: "Oops!", message: `Please provide if all the vehicles are garaged.`, valid: false }
    }

    return { valid: true }
}